import { gql } from "@apollo/client"

export const PEOPLE_FOR_LINK_QUERY = gql(/* GraphQL */`
    query PeopleForLink {
        persons {
            ...PeopleForLink__Person
        }
    }
`);
